export default __webpack_public_path__ + "static/media/gel-flower-fresh-1.58ba0844.jpg";